import { render } from "./Hair.vue?vue&type=template&id=56cb637b&scoped=true"
import script from "./Hair.vue?vue&type=script&lang=js"
export * from "./Hair.vue?vue&type=script&lang=js"

import "./Hair.vue?vue&type=style&index=0&id=56cb637b&lang=css"
import "./Hair.vue?vue&type=style&index=1&id=56cb637b&scoped=true&lang=css"
import "./Hair.vue?vue&type=style&index=2&id=56cb637b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cb637b"]])

export default __exports__